import MoreGiftsIcon from '~public/assets/icons/moreGifts.svg';

import { OpenFeedContainer } from './styles';

type Props = {
	onClick: () => void;
};

export const OpenFeed = ({ onClick }: Props) => {
	return (
		<OpenFeedContainer onClick={onClick}>
			<MoreGiftsIcon />
		</OpenFeedContainer>
	);
};
